module.exports = __webpack_public_path__ + "img/@header_bg_group.2df2b9fd.jpg";